import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import {
   Breadcrumb,
   Button,
   Card,
   Col,
   Form,
   Image,
   Input,
   InputNumber,
   notification,
   Row,
   Select,
   Typography
} from 'antd'
import { CloseOutlined, EditOutlined, HomeOutlined, LeftCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { useHistory, useParams } from 'react-router-dom'
// import { CKEditor } from 'ckeditor4-react'
import { useStore } from 'src/hooks'
import { debounce, size } from 'lodash'
import FloatLabel from 'src/common/components/float-label'
import { useTranslation } from 'react-i18next'
import i18n from 'src/helpers/i18n'
import { createValidationRules } from 'src/helpers/validateRule'
import { observer } from 'mobx-react-lite'
import { useLoading } from 'src/common/components/LoadingContainer'
import { DEPOSIT_WITHDRAW_TYPE, getRoleName, getStatusThuChi, getUniqueCode, METHOD_LIST } from 'src/helpers/constants'
// import UploadableImageBox from './UploadableImageBox'

const { Title } = Typography

const FundCreateScreen = observer(() => {
   const history = useHistory()
   const [form] = Form.useForm()
   const UserStore = useStore('UserStore')
   const FundStore = useStore('FundStore')
   const { t } = useTranslation()
   const { id } = useParams<{ id: string }>()
   // const ckeditorRef = useRef<any>()
   const { showLoading, hideLoading } = useLoading()
   const [detail, setDetail] = useState<any>(null)

   const readOnly = useMemo(() => {
      if (history.location.pathname.includes('detail')) {
         return true
      } else {
         return false
      }
   }, [history.location])

   // Re-create rules when language changes
   const rule = useMemo(() => createValidationRules(), [i18n.language])
   const handleGetMemberFilter = () => {
      if (size(UserStore.listMemberFilter.rows) === 0) {
         UserStore.getMemberFilter()
      }
   }
   useEffect(() => {
      if (id && id !== 'create') {
         handleGetDetail()
      }
      handleGetMemberFilter()
   }, [id])

   // Fetch detail thông tin kênh bán hàng
   const handleGetDetail = useCallback(async () => {
      if (!id) {
         return
      }
      try {
         showLoading()

         if (FundStore.fundSelected) {
            setDetail(FundStore.fundSelected)

            // Cập nhật giá trị cho form khi nhận được dữ liệu từ API
            form.setFieldsValue({
               ...FundStore.fundSelected,
               status: getStatusThuChi(FundStore.fundSelected?.status)
            })

            // setTimeout(() => {
            //    //@ts-ignore
            //    ckeditorRef.current?.setData?.(fetchedDetail?.des)
            // }, 500)
         }
      } finally {
         hideLoading()
      }
   }, [])

   const onFinish = async (values: any) => {
      // Kiểm tra từng field required
      // for (const field of requiredFields) {
      //    const fieldValue = values[field.key]

      //    if (!fieldValue || (typeof fieldValue === 'string' && fieldValue.trim() === '')) {
      //       setActiveTab(field.tab)
      //       return // Dừng lại ngay khi phát hiện lỗi
      //    }
      // }
      console.log('values', values)

      // Submit the sanitized data
      const data = id ? await FundStore.updateFund(id, { ...values }) : await FundStore.createFund(values)
      console.log('data', data, ' id', id)

      if (data) {
         if (id) {
            notification.open({
               message: t('notification'),
               description: t('update_successfully'),
               type: 'success',
               placement: 'topRight'
            })
         } else {
            notification.open({
               message: t('notification'),
               description: t('create_successfully'),
               type: 'success',
               placement: 'topRight'
            })
         }
         history.goBack()
      }
   }

   const renderContent = () => {
      return (
         <div style={{ pointerEvents: readOnly ? 'none' : 'all' }}>
            <Card style={{ width: '100%', marginTop: '20px' }}>
               <Row
                  className="gx-flex-row"
                  gutter={12}
                  style={{
                     flex: 1,
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     paddingLeft: 0,
                     paddingRight: 0
                  }}
               >
                  {/* <Col xs={24} md={12} xl={12}>
                     <FloatLabel label={'Mã phiếu'} required>
                        <Form.Item name="code" rules={[]}>
                           <Input   placeholder={t('enter')} maxLength={20} disabled />
                        </Form.Item>
                     </FloatLabel>
                  </Col> */}
                  <Col xs={24} md={12} xl={12}>
                     <FloatLabel label={'Loại'} required>
                        <Form.Item name="type" rules={[rule.maxRuleCharacter100]}>
                           <Select>
                              {DEPOSIT_WITHDRAW_TYPE.map((item) => (
                                 <Select.Option key={item?.id} value={item?.id}>
                                    {item?.title}
                                 </Select.Option>
                              ))}
                           </Select>
                        </Form.Item>
                     </FloatLabel>
                  </Col>

                  <Col xs={24} md={12} xl={12}>
                     <FloatLabel label={'Người Nạp/Rút tiền'} required>
                        <Form.Item name="accountId" rules={[rule.maxRuleCharacter50]}>
                           <Select allowClear>
                              {UserStore.listMemberFilter?.rows?.map((u: any) => (
                                 <Select.Option key={u?.id} value={u?.id}>
                                    {u?.name}『{getRoleName(u?.role)}』
                                 </Select.Option>
                              ))}
                           </Select>
                        </Form.Item>
                     </FloatLabel>
                  </Col>
                  <Col xs={24} md={12} xl={12}>
                     <FloatLabel label={'Số point'} required>
                        <Form.Item name="price" rules={[rule.maxRuleCharacter50]}>
                           <InputNumber
                              min={1}
                              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                              maxLength={10}
                              onKeyDown={(e) => {
                                 if (
                                    !/[0-9]/.test(e.key) &&
                                    !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(e.key)
                                 ) {
                                    e.preventDefault()
                                 }
                              }}
                              onPaste={(e) => {
                                 const paste = e.clipboardData.getData('text')
                                 if (!/^\d+$/.test(paste)) {
                                    e.preventDefault()
                                 }
                              }}
                           />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
                  <Col xs={24} md={12} xl={12}>
                     <FloatLabel label={'Số tiền'} required>
                        <Form.Item name="priceVND" rules={[rule.maxRuleCharacter50]}>
                           <InputNumber
                              min={1}
                              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              parser={(value) => value!.replace(/\$\s?|(,*)/g, '')}
                              maxLength={10}
                              onKeyDown={(e) => {
                                 if (
                                    !/[0-9]/.test(e.key) &&
                                    !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(e.key)
                                 ) {
                                    e.preventDefault()
                                 }
                              }}
                              onPaste={(e) => {
                                 const paste = e.clipboardData.getData('text')
                                 if (!/^\d+$/.test(paste)) {
                                    e.preventDefault()
                                 }
                              }}
                           />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
               </Row>

               <Row
                  className="gx-flex-row"
                  gutter={12}
                  style={{
                     flex: 1,
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     paddingLeft: 0,
                     paddingRight: 0
                  }}
               >
                  <Col style={{}} xs={24} md={24}>
                     <FloatLabel label={'Mô tả'}>
                        <Form.Item name="description">
                           <Input.TextArea rows={3} placeholder={t('enter')} maxLength={256} readOnly={readOnly} />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
                  {!!id && (
                     <Col style={{}} xs={24} md={24}>
                        <FloatLabel label={'Trạng thái'}>
                           <Form.Item name="status">
                              <Input placeholder={t('enter')} maxLength={256} readOnly={readOnly} />
                           </Form.Item>
                        </FloatLabel>
                     </Col>
                  )}
               </Row>
               {/* <Row gutter={16}>
                  <Col span={24} style={{ padding: 0, marginTop: '10px' }}>
                     <FloatLabel label={'Ảnh mô tả'} required>
                        <Row
                           className="gx-flex-row"
                           style={{ flex: 1, alignItems: 'center', padding: 0, paddingTop: 20 }}
                        >
                           <UploadableImageBox value={licenseImage} onChange={setLicenseImage} label="Bằng lái" />
                           <UploadableImageBox value={frontImage} onChange={setFrontImage} label="Ảnh trước xe" />
                           <UploadableImageBox value={bodyImage} onChange={setBodyImage} label="Ảnh thân xe" />
                        </Row>
                     </FloatLabel>
                  </Col>
               </Row> */}
            </Card>
         </div>
      )
   }

   return (
      <div>
         <Row style={{ padding: '0 20px' }} className="gx-justify-content-between gx-align-items-center">
            <Col>
               <Title level={4}>{'Quản lý quỹ'}</Title>
               <Breadcrumb>
                  <Breadcrumb.Item href="/">
                     <HomeOutlined className="gx-link" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{'Admin'}</Breadcrumb.Item>
                  <Breadcrumb.Item onClick={() => history.goBack()} className="gx-link">
                     {'Quản lý quỹ'}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{id ? (readOnly ? t('details') : t('edit')) : t('add_new')}</Breadcrumb.Item>
                  {id && <Breadcrumb.Item>{id}</Breadcrumb.Item>}
               </Breadcrumb>
            </Col>
         </Row>
         <Form
            form={form}
            name="basic"
            initialValues={{}}
            autoComplete="off"
            layout="vertical"
            onFinish={debounce(onFinish, 600)}
            onFinishFailed={(errorInfo) => {
               console.log('Validation Failed:', errorInfo)
            }}
         >
            {renderContent()}
            <Form.Item style={{ width: '100%', textAlign: 'center' }}>
               {readOnly ? (
                  <Button
                     icon={<LeftCircleOutlined />}
                     type="dashed"
                     style={{ color: '#ED5C19' }}
                     onClick={() => history.goBack()}
                  >
                     {t('txt_back')}
                  </Button>
               ) : (
                  <>
                     <Button
                        icon={<LeftCircleOutlined />}
                        type="dashed"
                        style={{ color: '#ED5C19' }}
                        onClick={() => history.goBack()}
                        className="gx-mr-2"
                     >
                        {t('txt_back')}
                     </Button>
                     <Button
                        icon={id ? <EditOutlined /> : <PlusCircleOutlined />}
                        type="primary"
                        htmlType="submit"
                        className="gx-mr-2"
                     >
                        {id ? t('update') : t('create')}
                     </Button>
                  </>
               )}
            </Form.Item>
         </Form>
      </div>
   )
})

export default FundCreateScreen
